import React, { useState, useEffect } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import { fetchSubSkills,searchSubSkills,searchSubSkillsDepartment } from '../../../../Redux/Actions/subSkillAction';

const SearchFilter = ({departments}) => {
	const dispatch = useDispatch();
   
    const initialValues = {
        skillName: "",
        dept_id: "",
      };
      const [values, setValues] = useState(initialValues);
    
      const { skillName, dept_id } = values;
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        
        setValues({ ...values, [name]: value });
        
       
      };
  
    const handleSearch = () => {
        if(!skillName && !dept_id) {
          dispatch(searchSubSkills(skillName));
          dispatch(searchSubSkillsDepartment(dept_id));
        }
        
        if(skillName) dispatch(searchSubSkills(skillName));
        if(dept_id) dispatch(searchSubSkillsDepartment(dept_id));
        // if(skillName !== '' && dept_id !==''){
        //   dispatch(searchSubSkills(skillName));
        //   dispatch(searchSubSkillsDepartment(dept_id));
        // }
    }
  
    const handleClearSearch = () =>{
      dispatch(fetchSubSkills());
      setValues({skillName:'',dept_id:''})
    }
	
    
	return (
		
        <div className="dash_white_box2 mb20 p20">
        <div className="dash_white_box_ttl">Search</div>
        <div className="row mb10">
          <div className="col-lg-3 col-md-6 pr07">
            <label className="form-label">Skill Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Search"
              name='skillName'
              value={skillName}
              onChange={handleChange}
            />
          </div>
          <div className="col-lg-3 col-md-6 pl07 pr07">
            <label className="form-label">Devision</label>
            <div className="form-input">
              <select
                className="form-select"
                name="dept_id"
                value={dept_id}
                onChange={handleChange}
              >
                <option value={""}>Select Devision </option>
                {departments && 
                departments?.map((dept,i) =>{
                    return (
                    <option key={i} value={dept.id}>{dept.name}</option>
                    )
                })}
              </select>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 pr07">
            <label className="h49 mb10"></label>
            <button onClick={handleSearch} className="btn_5 mr10">
              Search
            </button>
            <button onClick={handleClearSearch} className="btn_6">
              Reset
            </button>
          </div>
        </div>
      </div>
	);
};

export default SearchFilter;